import { useEffect, useRef } from "react";
import useTranslator from "../../hooks/useTranslator";

export function KycDocLoader({ showPopup, isGuarantor }) {
  const orbiterRef = useRef(null);
  const { _t } = useTranslator();

  useEffect(() => {
    let angle = 0;
    let animationFrameId;

    const animate = () => {
      angle += 0.5; // degrees
      const radius = 65;
      const centerX = 100;
      const centerY = 100;

      const radian = (angle * Math.PI) / 45;
      const x = centerX + radius * Math.cos(radian);
      const y = centerY + radius * Math.sin(radian);

      if (orbiterRef.current) {
        orbiterRef.current.setAttribute("cx", x.toString());
        orbiterRef.current.setAttribute("cy", y.toString());
      }

      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    showPopup && (
      <div
        className={`popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center modal-fixed-screen z-50 wrapper-modal ${isGuarantor ? "guarantorBg" : ""}`}
        style={{ zIndex: 101 }}
      >
        <div className="popup-content2 popup-content bg-white analysis-popup">
          <div className="row relativeposition">
            <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section">
              <div className="authenticateid-header text-center">
                <h4>
                  {_t(
                    "analysingTheDigitalKyc",
                    "Text used in kyc loader at onboarding flow"
                  )}
                </h4>
                <p>
                  {_t(
                    "theDigitalKycIsBeingAnalysedByTheSkor",
                    "Text used in kyc loader at onboarding flow"
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="analysisLoaderWrapper mx-auto d-flex align-items-center justify-content-center">
            <svg width="100%" height="100%" viewBox="0 0 200 200">
              <defs>
                <linearGradient
                  id="purple-gradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#a78bfa" />
                  <stop offset="100%" stopColor="#7c3aed" />
                </linearGradient>
                <linearGradient
                  id="green-orbiter-gradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#4ade80" />
                  <stop offset="100%" stopColor="#16a34a" />
                </linearGradient>
                <filter
                  id="doc-shadow"
                  x="-50%"
                  y="-50%"
                  width="200%"
                  height="200%"
                >
                  <feDropShadow
                    dx="0"
                    dy="5"
                    stdDeviation="5"
                    floodColor="#7c3aed"
                    floodOpacity="0.3"
                  />
                </filter>
                <filter
                  id="orbiter-shadow"
                  x="-50%"
                  y="-50%"
                  width="200%"
                  height="200%"
                >
                  <feDropShadow
                    dx="0"
                    dy="2"
                    stdDeviation="2"
                    floodColor="#16a34a"
                    floodOpacity="0.4"
                  />
                </filter>
              </defs>

              {/* Static Background Circle */}
              <circle cx="100" cy="100" r="65" fill="#dcfce7" />

              {/* Animated Orbiter */}
              <circle
                ref={orbiterRef}
                cx="100"
                cy="35"
                r="8"
                fill="url(#green-orbiter-gradient)"
                filter="url(#orbiter-shadow)"
              />

              {/* ID Card in center */}
              <g filter="url(#doc-shadow)">
                <rect
                  x="60"
                  y="75"
                  width="80"
                  height="50"
                  rx="5"
                  fill="url(#purple-gradient)"
                />
                <rect
                  x="70"
                  y="85"
                  width="28"
                  height="30"
                  rx="3"
                  fill="rgba(255,255,255,0.3)"
                />
                <circle cx="84" cy="95" r="7" fill="rgba(255,255,255,0.4)" />
                <path
                  d="M79 102 a5,5 0 0 1 10,0 a5,5 0 0 1 -10,0"
                  fill="rgba(255,255,255,0.4)"
                />
                <g fill="rgba(255,255,255,0.6)">
                  <rect x="105" y="88" width="25" height="4" rx="2" />
                  <rect x="105" y="98" width="25" height="4" rx="2" />
                  <rect x="105" y="108" width="15" height="4" rx="2" />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    )
  );
}
